export default __webpack_public_path__ + "static/media/fortune-07.7dcf6b7c.png";